import React, { useEffect, useState } from 'react'
import { number } from 'prop-types'
import { motion, useViewportScroll } from 'framer-motion'

import './ScrollPercentage.scss'

const ScrollPercentage = ({ readTime }) => {
  const { scrollYProgress } = useViewportScroll()
  let [currentScrollY, setCurrentV] = useState(0)
  let visible = false

  useEffect(() => {
    return scrollYProgress.onChange((v) => {
      setCurrentV(v)
    })
  }, [scrollYProgress])

  if (currentScrollY > 0.1) {
    visible = true
  }
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: visible ? 1 : 0,
      }}
      className="column is-1 scroll-percentage"
    >
      <div className="scroll-percentage__container">
        <div className="scroll-percentage__read-time">read: {readTime} min</div>
        <div className="scroll-percentage__indicator">
          {Math.round(currentScrollY * 100)}%
        </div>
      </div>
    </motion.div>
  )
}

ScrollPercentage.propTypes = {
  readTime: number,
}

export default ScrollPercentage
